import type { PortfolioBacktestDiagnostics } from '@einhaus/project314-types';
import Alert from '@/components/UI/Alert';

export default function PortfolioInputCoverageSummary({ diagnostics }: { diagnostics: PortfolioBacktestDiagnostics | null }) {
    const coverage = diagnostics?.inputCoverage;
    if (!coverage) return null;
    const exclusions = diagnostics?.inputExclusions ?? [];
    return (
        <div className="mb-4">
            <p className="text-sm text-zinc-300">
                Entry-data coverage: {coverage.evaluatedEntityCount} evaluated / {coverage.requestedEntityCount} requested strategy-symbol
                targets; {coverage.excludedEntityCount} excluded. Evaluated targets can legitimately produce no entries.
            </p>
            {coverage.excludedEntityCount > 0 && (
                <Alert variant="warning">
                    Results cover the available inputs. Unavailable symbols contributed no entries and are not counted as successful
                    zero-entry evaluations. Compare runs using the same exclusions for their shared strategies.
                    <details className="mt-2">
                        <summary>Excluded input details ({coverage.excludedEntityCount})</summary>
                        <ul className="mt-2 list-disc pl-5">
                            {exclusions.slice(0, 50).map((row) => (
                                <li key={`${row.strategyId}:${row.entityType}:${row.entityId}`}>
                                    {row.symbol ?? `${row.entityType} #${row.entityId}`} · strategy #{row.strategyId} ·{' '}
                                    {row.stage === 'sourceCoverage' ? 'source coverage' : 'entry discovery'}:{' '}
                                    {row.failureReason ?? row.failureCode}
                                </li>
                            ))}
                        </ul>
                        {exclusions.length > 50 && <p>Showing the first 50 exclusions. The full report retains all {exclusions.length}.</p>}
                        {exclusions.length === 0 && <p>Detailed exclusion evidence is unavailable in this summary.</p>}
                    </details>
                </Alert>
            )}
        </div>
    );
}
